import axiosInstance from '../plugin/axios';

interface FetchAdminMemberParams {
  memberType?: string;
  cityProvince?: string;
  district?: string;
  searchTerm?: string;
  offset?: number;
  limit?: number;
  sortBy?: string;
  order?: 'asc' | 'desc';
}

interface MemberDtoRx {
  userid: number; // 아이디 (숫자 타입)
  passid: string; // 로그인 아이디 (문자열 타입)
  memberType: string; // 회원 구분 (문자열 타입)
  name: string; // 회사명 (문자열 타입)
  address: string; // 지역 구분 (문자열 타입)
  charge: string; // 담당자 이름 (문자열 타입)
  position: string; // 담당자 직책 (문자열 타입)
  phone: string; // 휴대전화 (문자열 타입)
  createdAt: string; // 가입일 (문자열, 날짜 형식으로 예상)
  state: string; // 계정 상태 (문자열 타입)
}

interface DeleteMemberDtoTx {
  userId: number[]; // 회원 아이디 배열
}

interface ApproveMemberDtoTx {
  userId: number[]; // 회원 아이디 배열
}

interface DetailMemvberDriverDtoRx {
  memberType: string;
  passid: string;
  phone: string;
  registration: string;
}

interface DetailMemberCompanyDtoRx {
  memberType: string;
  passid: string;
  phone: string;
  name: string;
  address: string;
  addressDivision: string;
  charge: string;
  position: string;
  registration: string;
}

interface ServerResponse {
  statusCode: number;
  message: string;
}

export const fetchAdminMemberList = async (
  params: FetchAdminMemberParams,
): Promise<MemberDtoRx[]> => {
  try {
    const {
      memberType,
      cityProvince,
      district,
      searchTerm,
      offset = 0,
      limit = 10000,
      sortBy = 'createdAt',
      order = 'desc',
    } = params;
    const response = await axiosInstance.get<MemberDtoRx[]>(
      `/api/admin/member`,
      {
        params: {
          memberType,
          cityProvince,
          district,
          searchTerm,
          offset,
          limit,
          sortBy,
          order,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const fetchDeleteMember = async (
  data: DeleteMemberDtoTx,
): Promise<ServerResponse> => {
  try {
    const response = await axiosInstance.delete<ServerResponse>(
      `/api/admin/member`,
      {
        data: data, // userId 배열을 payload로 보냄
      },
    );
    return response.data; // 성공적으로 삭제한 후의 응답 데이터 반환
  } catch (error) {
    console.error('Failed to delete members:', error);
    throw error; // 에러 발생 시 처리
  }
};

export const fetchApproveMember = async (
  data: ApproveMemberDtoTx,
): Promise<ServerResponse> => {
  try {
    const response = await axiosInstance.post<ServerResponse>(
      `/api/admin/member/approve`,
      data,
    );

    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const fetchAdminDriverDetail = async (
  userId: number,
): Promise<DetailMemvberDriverDtoRx> => {
  try {
    const response = await axiosInstance.get<DetailMemvberDriverDtoRx>(
      `/api/admin/member/driver/${userId}`,
    );
    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const fetchAdminCompanyDetail = async (
  userId: number,
): Promise<DetailMemberCompanyDtoRx> => {
  try {
    const response = await axiosInstance.get<DetailMemberCompanyDtoRx>(
      `/api/admin/member/company/${userId}`,
    );
    return response.data;
  } catch (error) {
    throw new Error();
  }
};
